import script from "./ChampagneView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChampagneView.vue?vue&type=script&setup=true&lang=js"

import "./ChampagneView.vue?vue&type=style&index=0&id=6d826811&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d826811"]])

export default __exports__